import React from "react";
import { makeStyles } from "tss-react/mui";

import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle
} from "@mui/material";

import Box from "@mui/material/Box";
import GridContainer from "components/common/GridContainer";
import GridItem from "components/common/GridItem";
import DText from "components/common/DText";
import DButton from "components/common/DButton";
import { CloseOutlined } from "@mui/icons-material";
import dayjs from "dayjs";

const useStyles = makeStyles()((theme) => ({
    dialogTitleStyle: {
        fontWeight: 600,
        textTransform: "uppercase", // Optional, matching visual style
        color: "text.primary",
        pb: 2
    }
}));

export default function MaintenanceDialog({
    open,
    title,
    children,
    onSave,
    onCancel,
    canSave,
    icon,
    loading
}) {
    const { classes } = useStyles();
    return (
        <Dialog
            open={open}
            onClose={onCancel}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: {
                    p: 1,
                    borderRadius: 1.5
                }
            }}
        >
            <DialogTitle
                sx={{
                    fontWeight: 600,
                    color: "text.primary",
                    pb: 1
                }}
            >
                <GridContainer justifyContent="space-between">
                    <GridItem>
                        <DText md light>
                            <GridContainer noWrap alignItems="center">
                                <GridItem
                                    sx={{
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    {icon}
                                </GridItem>
                                <GridItem>
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 0,
                                            lineHeight: 1.3
                                        }}
                                    >
                                        <DText bolder md>
                                            {title}
                                        </DText>
                                        <DText light sm>
                                            {dayjs()?.format(
                                                "dddd, DD MMM YYYY"
                                            )}
                                        </DText>
                                    </div>

                                    {/*<GridContainer
                                        spacing={0}
                                        direction="column"
                                    >
                                        <GridItem>{title}</GridItem>
                                        <GridItem>
                                            <DText light sm>
                                                {dayjs()?.format(
                                                    "YYYY-MM-DD HH:mm:ss"
                                                )}
                                            </DText>
                                        </GridItem>
                                    </GridContainer>*/}
                                </GridItem>
                            </GridContainer>
                        </DText>
                    </GridItem>
                    <GridItem>
                        <DButton
                            sx={{ padding: 0 }}
                            onClick={onCancel}
                            size="small"
                            minWidth="unset"
                        >
                            <CloseOutlined />
                        </DButton>
                    </GridItem>
                </GridContainer>
            </DialogTitle>

            <DialogContent dividers>
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: 2.5,
                        pt: 1
                    }}
                    className={classes.dialogTitleStyle}
                >
                    {children}
                </Box>
            </DialogContent>

            <DialogActions sx={{ pt: 2, pb: 1, pr: 2 }}>
                <Button
                    onClick={onCancel}
                    sx={{ color: "secondary.main", fontWeight: 600 }}
                    variant="outlined"
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    onClick={onSave}
                    disabled={!canSave}
                    loading={loading}
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}
